import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import OnboardingModal from './index';
import { ONBOARDING_ROUTES } from 'constants/Routes';

const CustomizeSurvey = ({ path, setModalStatus }) => {
  const [isVisible, toggleModal] = useState(path === ONBOARDING_ROUTES.STEP_TWO);
  useEffect(() => {
    setModalStatus(isVisible);
  }, [isVisible]);

  const handleContinue = () => {
    setModalStatus(false);
    toggleModal(false);
  }

  return (
    <OnboardingModal
      isVisible={isVisible}
      handleContinue={handleContinue}
      buttonText={"Customize Your Survey"}
    >
      <h2>You've selected a great template!</h2>
      <p>Now let's customize it</p>
      <hr align="left" className="subheading-divider"></hr>
      <ul className="onboarding-modal-list">
        <li>
          <FontAwesomeIcon icon="check-circle" className="text-success" />Name your Survey
        </li>
        <li>
          <FontAwesomeIcon icon="check-circle" className="text-success" />Add an address(optional)
        </li>
        <li>
          <FontAwesomeIcon icon="check-circle" className="text-success" />Provide an incentive for taking the survey (recommended)
        </li>
      </ul>
    </OnboardingModal>
  );
};

CustomizeSurvey.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func
};

export default CustomizeSurvey;



// WEBPACK FOOTER //
// ./src/components/Onboarding/Modal/CustomizeSurvey.js